import {
  ADD_ZONE_LOADING,
  DELETE_ZONE_FAILURE,
  DELETE_ZONE_LOADING,
  DELETE_ZONE_SUCCESS,
  FETCH_ZONE_FAILURE,
  FETCH_ZONE_LOADING,
  FETCH_ZONE_SUCCESS,
  UPDATE_ZONE_FAILURE,
  UPDATE_ZONE_LOADING,
  UPDATE_ZONE_SUCCESS
} from '../Types/zoneTypes';

const initState = {
  data: [],
  error: null,
  success: null,
  loading: true,
  item: {}
};

const zoneReducer = function (state = initState, action) {
  switch (action.type) {
    case ADD_ZONE_LOADING:
    case FETCH_ZONE_LOADING:
    case UPDATE_ZONE_LOADING:
    case DELETE_ZONE_LOADING:
      return {
        ...state,
        loading: true
      };

    case FETCH_ZONE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        data: action.payload
      };

    case UPDATE_ZONE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.map(item => (item._id === action.payload._id ? action.payload : item)),
        error: null,
        success: 'Floor updated successfully'
      };

    case DELETE_ZONE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: 'Floor removed successfully',
        data: state.data.filter(item => item._id !== action.payload)
      };

    case FETCH_ZONE_FAILURE:
    case UPDATE_ZONE_FAILURE:
    case DELETE_ZONE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };

    default:
      return { ...state };
  }
};

export default zoneReducer;
